import defs from '../_core/defs.js';
// a write to length, the method's own or a native method's, goes through length's accessor;
// it gets the method's options, so silent: true fires no change:length either
export default function withLengthOptions(self, eventOptions, run) {
  var _defs$get;
  var propDef = (_defs$get = defs.get(self)) == null ? void 0 : _defs$get.props.length;
  if (!propDef || !eventOptions) {
    return run();
  }
  var previous = propDef.setterOptions;
  propDef.setterOptions = eventOptions;
  try {
    return run();
  } finally {
    propDef.setterOptions = previous;
  }
}